export const ArrowUp = () => {
	return (
		<svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M7.99995 15.5832C4.12932 15.5832 0.999878 12.4537 0.999878 8.58308C0.999878 4.71245 4.12932 1.58301 7.99995 1.58301C11.8706 1.58301 15 4.71245 15 8.58308C15 12.4537 11.8706 15.5832 7.99995 15.5832ZM7.99995 2.40655C4.58227 2.40655 1.82342 5.1654 1.82342 8.58308C1.82342 12.0008 4.58227 14.7596 7.99995 14.7596C11.4176 14.7596 14.1765 12.0008 14.1765 8.58308C14.1765 5.1654 11.4176 2.40655 7.99995 2.40655Z"
				fill="white"
			/>
			<path
				d="M11.4197 9.28255L8.00197 5.86487L4.58429 9.28255L4.00781 8.70607L8.00197 4.71191L11.9961 8.70607L11.4197 9.28255Z"
				fill="white"
			/>
			<path d="M7.58594 5.28613H8.40948V12.2862H7.58594V5.28613Z" fill="white" />
		</svg>
	);
};
